"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyLeadDetailDto = instanceOfPropertyLeadDetailDto;
exports.PropertyLeadDetailDtoFromJSON = PropertyLeadDetailDtoFromJSON;
exports.PropertyLeadDetailDtoFromJSONTyped = PropertyLeadDetailDtoFromJSONTyped;
exports.PropertyLeadDetailDtoToJSON = PropertyLeadDetailDtoToJSON;
exports.PropertyLeadDetailDtoToJSONTyped = PropertyLeadDetailDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyLeadDetailDto interface.
 */
function instanceOfPropertyLeadDetailDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    return true;
}
function PropertyLeadDetailDtoFromJSON(json) {
    return PropertyLeadDetailDtoFromJSONTyped(json, false);
}
function PropertyLeadDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'crmEnquiryId': json['crmEnquiryId'] == null ? undefined : json['crmEnquiryId'],
        'source': json['source'] == null ? undefined : json['source'],
        'email': json['email'] == null ? undefined : json['email'],
        'personName': json['personName'] == null ? undefined : json['personName'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'body': json['body'] == null ? undefined : json['body'],
    };
}
function PropertyLeadDetailDtoToJSON(json) {
    return PropertyLeadDetailDtoToJSONTyped(json, false);
}
function PropertyLeadDetailDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'crmEnquiryId': value['crmEnquiryId'],
        'source': value['source'],
        'email': value['email'],
        'personName': value['personName'],
        'phoneNumber': value['phoneNumber'],
        'subject': value['subject'],
        'body': value['body'],
    };
}
